/**
 * The parkify-cs origin the ops console talks to.
 *
 * ONE definition. This used to be copy-pasted into every screen that calls cs —
 * Customers, Permits, Integrations, KbCandidatesWidget — each with its own hand-
 * typed production fallback. A fifth copy, added for the support sales-channel
 * lookup, was typed with the WRONG project number and WRONG region
 * (`parkify-cs-609246881753.us-east1`), naming a host that does not exist.
 *
 * It would have failed SILENTLY: that lookup is best-effort, so a dead origin is
 * indistinguishable from "this lot has no external sales channel" — the one
 * answer that surface must never fabricate. Caught in review before it shipped;
 * the duplication is what made it possible at all.
 *
 * ⚠️ The fallback is PRODUCTION. A local dev build with no `VITE_CS_API_BASE`
 * reads live parkify-cs rather than failing loudly. That is the pre-existing
 * convention and is kept deliberately: the ops console is staff-only and every
 * cs route it touches is staff-gated server-side. Set `VITE_CS_API_BASE` when
 * pointing at a local cs.
 */
import { createCaller } from '@parkify/api-client'

export const CS_BASE = (import.meta.env.VITE_CS_API_BASE as string | undefined)
  ?? 'https://parkify-cs-656016349174.us-central1.run.app'

/** `callCs(path, init)`: the same request as before, against CS_BASE; see `callApi`. */
export const callCs = createCaller(CS_BASE)
